import { createContext } from 'react';
// Current user profile details
export const CurrentUserDetails = createContext([{}, () => {}]);
// Active Edit Member
export const ActiveMember = createContext([{}, () => {}]);
// training context
export const TrainingContext = createContext([{}, () => {}]);
